<template>
  <div class="Rectangle">
    <ProcessedPostText :content="content" />
  </div>
</template>


<script>
import ProcessedPostText from "./processed-text.vue";

export default {
  name: "PostText",
  components: {
    ProcessedPostText: ProcessedPostText,
  },
  props: {
    content: {
      type: String,
    },
  },
};
</script>


<style scoped>
.Rectangle {
  /* margin: 206.1px 24px 306.7px 280px; */
  /* padding: 34.7px 15.2px 23.6px 11.5px; */
  /* background-color: rgba(1, 2, 1, 0.5); */
  /* display: flex; */
  /* UNCOMMENT THE FOLLLOWING  */
  /*  
 z-index:100;
  text-align: center;;
  left: 36%;
  bottom: 15%;
  position: fixed;
 */
  /* bottom: 200.5px; */
  width: 90%;
  text-shadow: 0 1px 0 rgba(0, 0, 0, 0.33);
  font-size: 0.84rem;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.3;
  letter-spacing: 0.4px;
  text-align: left;
  color: #fff;
  font-weight: 300;
}
</style>